import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, CONSENT_EVENT } from "@/lib/consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(() => !getConsent());
  useEffect(() => {
    const h = () => setShow(!getConsent());
    window.addEventListener(CONSENT_EVENT, h);
    return () => window.removeEventListener(CONSENT_EVENT, h);
  }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t-4 border-gold shadow-[0_-12px_40px_rgba(9,31,66,0.25)] fade-in" data-testid="cookie-banner" role="dialog" aria-label="Avviso cookie">
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <Cookie className="w-7 h-7 text-[#C98A3C] shrink-0 hidden md:block"/>
        <p className="text-sm text-aic-navy flex-1 leading-relaxed">
          Usiamo cookie e strumenti tecnici necessari al funzionamento del portale e, solo con il tuo consenso, statistiche di visita che ci aiutano a migliorarlo.
          Se rifiuti, le visite vengono conteggiate solo in forma anonima. <Link to="/cookie-policy" data-testid="cookie-banner-policy" className="font-semibold underline text-aic-navy hover:text-[#C98A3C]">Leggi la Cookie Policy</Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => setConsent("rejected")} data-testid="cookie-reject" className="btn-pill-outline text-sm">Rifiuta</button>
          <button onClick={() => setConsent("accepted")} data-testid="cookie-accept" className="btn-pill-gold text-sm">Accetta</button>
        </div>
      </div>
    </div>
  );
};
